import { render, staticRenderFns } from "./BasePricingPanel.vue?vue&type=template&id=e84cb36e"
import script from "./BasePricingPanel.vue?vue&type=script&lang=js"
export * from "./BasePricingPanel.vue?vue&type=script&lang=js"
import style0 from "./BasePricingPanel.vue?vue&type=style&index=0&id=e84cb36e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports